export default {
      id: "missed-round-usage",
      viewBox: "0 0 19 17",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#missed-round",
      toString: function () {
        return this.url;
      }
    }